import { memo, useEffect, useState } from 'react';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

export const StatusCircle = memo(({ status, disabled }) => {
  const [color, setColor] = useState('error');
  useEffect(() => {
    if (disabled) {
      setColor('primary');
      return;
    }
    const isOnline = status ? 'success' : 'error';
    setColor(isOnline);
  }, [status, disabled]);

  return <FiberManualRecordIcon fontSize="0.8rem" color={color.toString()} />;
});
